import { FlexComponentBootstrap } from "../../../common/component-bootstraper";
import HeaderApp from './react-header.jsx';
var header = new FlexComponentBootstrap('header', '', 'header');
header.reactApp = HeaderApp;
header.run();